import gql from 'graphql-tag';

const DriverAssignments = gql(/* GraphQL */ `
  query DriverAssignments($eventAtRange: TimeRangeInput) {
    driverAssignments(eventAtRange: $eventAtRange) {
      id
      delivery {
        id
        eventAt
        orderNumber
        pickupAddress {
          id
          timeZoneIdentifier
        }
        dropoffAddress {
          id
          street1
          street2
          city
          state
          zip
        }
        status
      }
    }
  }
`);

export default DriverAssignments;
